import { motion } from "framer-motion";
import { resolveImageUrl } from "@/components/ImageUpload";

export default function Padrinos({ padrinos }) {
  const list = (padrinos || []).filter((p) => p.role || p.names);
  if (list.length === 0) return null;

  return (
    <section className="py-14 px-6 md:px-10 bg-sand/50">
      <div className="text-center mb-10">
        <p className="overline">Con el cariño de</p>
        <h3 className="headline text-4xl text-ink mt-3">Padrinos y bendiciones</h3>
      </div>
      <div className="max-w-lg mx-auto grid grid-cols-1 gap-4">
        {list.map((p, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.06 }}
            className="glass rounded-2xl p-5 text-center"
          >
            {p.sticker_url && (
              <img src={resolveImageUrl(p.sticker_url)} alt="" className="h-40 w-auto max-w-[90%] object-contain mx-auto mb-2 drop-shadow-md" data-testid="padrino-sticker" />
            )}
            <p className="text-xs tracking-[0.25em] uppercase text-warmgold">{p.role}</p>
            <p className="fn-body-font text-xl text-ink mt-2">{p.names}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
